var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: ["progress-bar-container", _setup.props.file.status] },
    [
      _c("div", { staticClass: "info-container" }, [
        _c("div", { staticClass: "file-name-container" }, [
          _c("span", { staticClass: "file-icon e-fe-pdf" }),
          _c("span", { staticClass: "file-name" }, [
            _vm._v(_vm._s(_setup.computedFileName)),
          ]),
        ]),
        _c("div", { staticClass: "status-container" }, [
          _c("span", { staticClass: "status-info" }, [
            _vm._v(_vm._s(_setup.computedInfoText)),
          ]),
          _c("span", { class: [_setup.computedInfoIcon, "status-icon"] }),
        ]),
      ]),
      _c("v-progress-linear", {
        attrs: {
          indeterminate: _setup.computedIndeterminate,
          rounded: "",
          color: _setup.vars.progress_bar_success,
          "background-color": _setup.computedBackgroundColor,
        },
      }),
      _setup.computedErrorText
        ? _c("span", { staticClass: "error-text" }, [
            _vm._v(_vm._s(_setup.texts.errorText)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }